import { Box, Button, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";

const SivooTVPlus = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <div>
      <Box sx={{ mb: 2, textAlign: "center" }}>
        <img src="./assets/images/sivootv-plus-logo.png" alt="" />
        <Typography variant="h3">
          A Traditional Television Experience
        </Typography>
      </Box>
      <Stack
        sx={{ my: 6 }}
        justifyContent="center"
        direction="row"
        flexWrap="wrap"
        gap={1}
      >
        <a
          href="https://plus.sivootv.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img className="storeLogo" src="./assets/icons/btn_loginTV+.png" alt="Login to watch now" title="Login to watch now"/>
        </a>
        <a
          href="https://apps.apple.com/us/app/sivootv/id6449462901"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img className="storeLogo" src="./assets/icons/btn_app.png" alt="Get it on your iOS device" title="Get it on your iOS device"/>
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=com.sivoo.apps"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img className="storeLogo" src="./assets/icons/btn_play.png" alt="Get it on your Android device" title="Get it on your Android device"/>
        </a>
        <a
          href="https://www.amazon.com/Sivoo-SivooTV/dp/B0C74PBL8T/ref=sr_1_1"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img className="storeLogo" src="./assets/icons/btn_firetv.png" alt="Get it on your Amazon device" title="Get it on your Amazon device"/>
        </a>
        <a
          href="https://channelstore.roku.com/details/1d27444bbc7e5902df6544fa7048ea2d/sivootv"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img className="storeLogo" src="./assets/icons/btn_rokutv.png" alt="Get it on your Roku device" title="Get it on your Roku device"/>
        </a>
        <a
          href="https://www.samsung.com/us/tvs/smart-tv/samsung-tv-plus-and-smart-hub/"
          rel="noopener noreferrer"
        >
          <img className="storeLogo" src="./assets/icons/btn_samsungtv.png" alt="Get it on your Samsung Smart TV" title="Get it on your Samsung Smart TV"/>
        </a>
        <a
          href="https://us.lgappstv.com/main/tvapp/detail?appId=1221388"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img className="storeLogo" src="./assets/icons/btn_lgtv.png" alt="Get it on your LG Smart TV" title="Get it on your LG Smart TV"/>
        </a>
      </Stack>
      <Box sx={{ textAlign: isMobile ? "left" : "justify" }}>
        <Stack sx={{ mb: 6 }} direction="row" justifyContent="center" gap={2}>
          <img
            style={{
              borderRadius: "25px",
            }}
            src="./assets/images/sivootv-plus.jpg"
            alt=""
          />
        </Stack>
        <Typography sx={{ my: 2, px: 4, }} variant="body1">
          SivooTV+ is an option to a traditional cable package with all the channels you recognize from the most popular creators; 100% licensed. With tiers for all budgets, we are able to match most channel lineups and beat prices. Check out our <Link to="/plus">packages</Link>, <Link to="/plus/channels">channels</Link> and <Link to="/plus/isps-mdus">ISP/MDU</Link> offerings.
        </Typography>
      </Box>
      <Stack sx={{ mt: 4 }} columns={{ xs: 1, sm: 2 }} direction="row" justifyContent="center" gap={2} useFlexGap flexWrap="wrap">
        <Button onClick={() => navigate("/plus")} variant="contained">Packages</Button>
        <Button onClick={() => navigate("/plus/channels")} variant="contained">Channels</Button>
        <Button onClick={() => navigate("/plus/instructions")} variant="contained">Instructions</Button>
        <Button onClick={() => navigate("/plus/isps-mdus")} variant="contained">ISPs/MDUs</Button>
        <Button onClick={() => navigate("/plus/signup")} variant="contained" sx={{ color: "#fff", whiteSpace: "nowrap", }} color="secondary">Sign Up</Button>
      </Stack>
    </div>
  );
};

export default SivooTVPlus;
